<div class="md-form md-outline">
  <jhi-bary-icon *ngIf="icon" [icon]="icon" [faDirective]="FAR" class="suffix"></jhi-bary-icon>
  <input
    mdbInput
    [type]="transformFunction ? 'text' : 'number'"
    class="form-control"
    [formControl]="transformFunction ? _control : control"
    [id]="id"
    [placeholder]="placeholder"
    [mdbValidate]="true"
    [validateSuccess]="false"
    [class.invalid]="control && control.invalid && (control.dirty || control.touched)"
    [class.disabled]="disabled || control.disabled"
    (keyup)="checkValue($event)"
    (blur)="formatTextValue()"
    [min]="min"
    [max]="max"
    [name]="id"
    jhiMarkAsterisk
    [step]="step"
  />
  <label [for]="id" class="{{ disabled || control.disabled ? 'bg-unset label-disabled' : '' }}">{{ label }}</label>
  <mdb-error *ngIf="control && control.invalid && (control.dirty || control.touched)" class="w-100">
    <ng-container *ngIf="control.hasError('required'); else whenValueIsIndicated">
      <span jhiTranslate="ERROR.REQUIRED_FIELD"></span>
    </ng-container>
    <ng-template #whenValueIsIndicated>
      <ng-container *ngIf="control.hasError('min') || control.hasError('max') || control.hasError('minNumber') || control.hasError('maxNumber'); else patternError"></ng-container>
      <span *ngIf="control.hasError('min')" [jhiTranslate]="keyTranslateMinError" [translateValues]="{ min: control.errors?.['min']?.min }"></span>
      <span *ngIf="control.hasError('max')" [jhiTranslate]="keyTranslateMaxError" [translateValues]="{ max: control.errors?.['max']?.max }"></span>
      <span *ngIf="control.hasError('minNumber')" [jhiTranslate]="keyTranslateMinError" [translateValues]="{ min: control.errors?.['min']?.min }"></span>
      <span *ngIf="control.hasError('maxNumber')" [jhiTranslate]="keyTranslateMaxError" [translateValues]="{ max: control.errors?.['max']?.max }"></span>
      <ng-template #patternError>
        <ng-container *ngIf="control.hasError('pattern'); else minMaxError">
          <span jhiTranslate="components.inputs.invalidPattern"></span>
        </ng-container>
        <ng-template #minMaxError>
          <ng-container *ngIf="control.hasError('invalidMinMaxValue'); else offsetError">
            <span jhiTranslate="components.inputs.errors.invalidMinMaxValue"></span>
          </ng-container>
          <ng-template #offsetError>
            <ng-container *ngIf="control.hasError('invalidValueForOffset')">
              <span
                jhiTranslate="ERROR.LOWER_THAN_OFFSET"
                [translateValues]="{ offset: control.errors?.['invalidValueForOffset']?.offset, offsetUnit: control.errors?.['invalidValueForOffset']?.offsetUnit }"
              ></span>
            </ng-container>
          </ng-template>
        </ng-template>
      </ng-template>
    </ng-template>
  </mdb-error>
</div>
